import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a5bd016"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "success__products"
};
const _hoisted_2 = {
  class: "success__products-item"
};
const _hoisted_3 = {
  class: "success__products-imgwrapper"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "success__products-info"
};
const _hoisted_6 = {
  class: "success__products-title"
};
const _hoisted_7 = {
  key: 0,
  class: "success__products-weight"
};
const _hoisted_8 = {
  key: 1,
  class: "success__products-weight"
};
const _hoisted_9 = {
  class: "success__products-box"
};
const _hoisted_10 = {
  class: "success__products-box-item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__products-box-name"
}, "Цена", -1));
const _hoisted_12 = {
  class: "success__products-box-value"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
const _hoisted_14 = {
  class: "success__products-box-item"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__products-box-name"
}, "Кол-во", -1));
const _hoisted_16 = {
  class: "success__products-box-value"
};
const _hoisted_17 = {
  class: "success__products-box-item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "success__products-box-name"
}, "Итого", -1));
const _hoisted_19 = {
  class: "success__products-box-value"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.products, (item, id) => {
    return _openBlock(), _createBlock(_component_router_link, {
      to: `/rol-shop/${item.category}/${item.id}`,
      key: id
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "success__products-img",
        src: require(`@/img/products/${item.imgUrl}`),
        alt: "tovar"
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1), item.weight ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Вес: " + _toDisplayString(item.weight) + " г ", 1)) : _createCommentVNode("", true), item.volume ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Объем: " + _toDisplayString(item.volume) + " л ", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("p", _hoisted_12, [_createTextVNode(_toDisplayString(item.price) + " ", 1), _hoisted_13])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("p", _hoisted_16, _toDisplayString(item.count), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("p", _hoisted_19, [_createTextVNode(_toDisplayString(item.price * item.count) + " ", 1), _hoisted_20])])])])]),
      _: 2
    }, 1032, ["to"]);
  }), 128))]);
}